import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Skeleton from "src/components/Skeleton"

import { capitalize } from "src/utils/string_helpers"

import ContractTable from "./ContractTable"

const TABS = ["unsent", "outstanding", "completed"]

function ContractTabs({ tabCounts, table }) {
  const currentTab = table.filters.tab

  const renderTabs = () => {
    return TABS.map((tab) => (
      <button
        key={tab}
        type="button"
        className={classNames(
          "flex-grow basis-0 rounded-t border py-3 font-semibold text-gray-900",
          {
            "border-b-0 bg-white": currentTab === tab,
            "bg-gray-200 hover:bg-gray-100": currentTab !== tab,
          }
        )}
        onClick={() => {
          table.setSelection([])
          table.setFilters({
            tab,
            search: "",
            statuses: [],
            inMarinaStartDate: null,
            inMarinaEndDate: null,
            journeyStage: "all",
            inactiveDays: null,
          })
        }}
      >
        {tabCounts ? (
          <>
            {tabCounts[tab] ?? 0} {capitalize(tab)}
          </>
        ) : (
          <span className="inline-flex items-center gap-2">
            <Skeleton.Bar width="w-6" height="h-4" />
            {capitalize(tab)}
          </span>
        )}
      </button>
    ))
  }

  return (
    <div>
      <div className="flex gap-1 print:hidden">{renderTabs()}</div>
      <ContractTable table={table} tab={currentTab} />
    </div>
  )
}

ContractTabs.propTypes = {
  tabCounts: PropTypes.shape({
    unsent: PropTypes.number,
    outstanding: PropTypes.number,
    completed: PropTypes.number,
  }),
  table: PropTypes.object.isRequired,
}

export default ContractTabs
